import { useContext } from "react";

import { PoliciesContext, defaultPolicy } from "@modules/cve/context";
import { upsertPolicy } from "@modules/cve/data";

import Button from "@mui/material/Button";

import { removeDuplicateObjectsByProperty } from '@utils';

const hasInputErrors = (policy) => {
	let errors = [];

	let { levels, hasExploit, vendors, products, cveIds } = policy;
	// console.log(`policy`, policy)
	let { computers, groups, companies, organizations } = levels;
	if (!computers.length && !groups.length && !companies.length && !organizations.length) errors.push("cveError_policyMissingAssignments");
	//if (!hasExploit && !vendors.length && !products.length && !cveIds.length) errors.push("cveError_policyTooBroad");

	return { errors };
};

export const PolicyFormSave = ({ handleCancel, activePolicy, setActivePolicy, setInputErrors }) => {
	const { setPolicies, policies } = useContext(PoliciesContext);

	const handleSave = async () => {
		let { errors } = hasInputErrors(activePolicy);

		if (errors.length) {
			setInputErrors(errors);
		} else {
			
			// set if we are editing an existing policy
			const policyToEdit = policies.find(p => p.policyId === activePolicy.policyId);
			
			// set policies state prior to updating on server
			setPolicies((prevState) => {
				// remove existing policy if policyId matches
				let filteredPolicies = prevState.filter((policy) => policy.policyId !== activePolicy.policyId);
				
				filteredPolicies.push(activePolicy);
				return filteredPolicies;
			});

			// reset active policy state to default
			const currentPolicy = activePolicy; //may not be needed
			setActivePolicy(defaultPolicy);
			// remove modal
			handleCancel();

			// add upsert policy via API
			let upsertedPolicy = await upsertPolicy({ policy: currentPolicy });

			const updatePolicies = (policies, newPolicy) => {
				// add new policy we are upserting to array
				policies.push(newPolicy);
				// de-dupe policies
				policies = removeDuplicateObjectsByProperty(policies, 'policyId');
				// remove any policies without a policyId
				policies = policies.filter((policy) => policy.policyId);

				return policies;
			};
			
			// ajax call failed
			if (!upsertedPolicy.ok) {
				// TODO: add an alert to the user that notifies them the policy creation has failed
				setPolicies(prevState => updatePolicies(prevState, policyToEdit));
			} else {
				setPolicies(prevState => updatePolicies(prevState, upsertedPolicy.data));
			}
		}
	};

	return (
		<div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
			{handleCancel && (
				<Button sx={{ width: "120px" }} color="secondary" onClick={handleCancel}>
					Cancel
				</Button>
			)}
			<Button sx={{ width: "120px" }} onClick={handleSave}>
				Save
			</Button>
		</div>
	);
};
